import { useCallback, useEffect, useState } from 'react'

import { Box, List, ListItem } from '@mui/material'
import { useParams } from 'react-router-dom'
import ErrorDisplay from '../../components/error/ErrorDisplay'
import { appParams } from './Organisation'
import { axiosPrivate } from '../../utils/axiosInstance'
import Loading from '../../Loading'

/**
 * Organisation deploy server list
 * @param {Props} Props props
 * @returns {JSX.Element}
 */
export function DeployServersList() {
  const { organisationID } = useParams<appParams>()

  const [isLoadingUsers, setLoadingUser] = useState(true)
  const [loadError, setLoadError] = useState(null)
  const [deploys, setDeploys] = useState<any[]>([])

  const getDeploys = useCallback(async () => {
    try {
      const { data } = await axiosPrivate.get(`${window.location.origin}/mqttapi/v1/deploy/server/${organisationID}`)
      setDeploys(data)
    } catch (error: any) {
      setLoadError(error)
    } finally {
      setLoadingUser(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    getDeploys()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (loadError !== null) {
    return <ErrorDisplay err={loadError} />
  }

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box>Deploy Servers</Box>
      </Box>
      {isLoadingUsers ? (
        <Loading />
      ) : (
        <List>
          {(deploys || []).length > 0 &&
            deploys.map((user, idx) => (
              <ListItem sx={{ marginBottom: '10px', borderRadius: '5px' }} key={idx}>
                <span>{user.name}</span>
              </ListItem>
            ))}
        </List>
      )}
    </>
  )
}
